<template>
<div>
<div class="input__radio radioClass">
        <input :id="`${_uid}-radio`" class="input__radio-item" type="radio" :value="option" v-model="selected" @click="clicked">
        <label class="input__radio-label" :for="`${_uid}-radio`" v-html="label"/>
        <img v-if="imgSrc" :src="imgSrc" height="30" width="30" alt="Paypal">
    </div>
    <div class="collapsible-container" :class="{'collapsible-container--active' : isSelected}">
        <slot/>
    </div>
</div>
</template>

<script>
export default {
    name: 'RadioField',
    props: {
        value: {
            required: true,
        },
        item: {
            type: Object,
        },
        selected: {
            type: String,
        },
    },
    data() {
        return {
            val: null,
        };
    },
    computed: {
        imgSrc() {
            return this.item?.icon;
        },
        option() {
            return this.item?.val;
        },
        label() {
            return this.item?.label;
        },
        isSelected() {
            return this.item?.isSelected;
        },
    },
    methods: {
        clicked() {
            this.$emit('clicked', this.option);
        },
    },
    watch: {
        val(value) {
            this.$emit('input', value);
        },
        value: {
            immediate: true,
            handler(value) {
                this.val = value;
            },
        },
    },
};
</script>

<style scoped>
.radioClass{
    background-color: #fff;
    border: 1px solid #DFDFDF;
    /* min-width: 400px; */
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 20px;
    padding-right: 10px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  @media only screen and (max-width: 500px) {
        .radioClass {
            /* min-width: 300px; */
            width: 100%;
        }
    }

  .collapsible-container{
        max-height: 0;
        transition: max-height 1s ease-in-out;
        overflow-y: hidden;
        background-color: #f6f6f6;
  }

  .collapsible-container--active{
        max-height: 500px;
  }
</style>
